import styled from 'styled-components'

import { DEFAULT_ROW_HEIGHT } from '../../DataTable.constants'

export const TableHeader = styled.thead`
  font-weight: ${props => props.theme.fontWeights.bold};
  background-color: ${props => props.theme.colors.white.base};
  z-index: 1;
  color: ${props => props.theme.colors.black.base};
  position: sticky;
  top: 0;
  min-height: ${DEFAULT_ROW_HEIGHT}px;
`

export const TableHead = styled.th`
  background-color: ${props => props.theme.colors.white.base};
  position: relative;
  display: flex;
  align-items: center;
  max-width: calc(var(--header-${props => props.id}-size) * 1px);
  min-width: calc(var(--header-${props => props.id}-size) * 1px);
  width: calc(var(--header-${props => props.id}-size) * 1px);
  border-bottom: 3px solid ${props => props.theme.colors.neutral.lighter};
  &:not(:last-child) {
    border-right: 2px solid ${props => props.theme.colors.neutral.lighter};
  }
`

export const HeadLabel = styled.div<{ $canSort: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  font-weight: normal;
  padding: ${props => props.theme.spacings.small};
  cursor: ${props => (props.$canSort ? 'pointer' : 'default')};
  user-select: none;
  gap: ${props => props.theme.spacings.xsmall};

  .table-head-label {
    flex: 1;
    min-width: 0;
    text-wrap: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`
